// Complete Your Kit - cart recommendation controller
class CompleteYourKit extends HTMLElement {
  connectedCallback() {
    this.band = 2000; // $20 nudge window (cents)
    this._viewed = false;
    this._tries = 0;
    this._filling = false;
    try { this.init(); } catch (e) {}
  }
  disconnectedCallback() { if (this._obs) { this._obs.disconnect(); } }
  init() {
    this.addEventListener('submit', this.onSubmit.bind(this));
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('change', function (e) { const s = e.target && e.target.closest ? e.target.closest('.cyk-card__size') : null; if (s) { s.classList.remove('cyk-card__size--error'); var _c = s.closest('[data-cyk-card]'); var _o = s.options && s.selectedIndex >= 0 ? s.options[s.selectedIndex] : null; if (_c && _o) { var _pm = _o.getAttribute('data-price-money'); var _pc = _o.getAttribute('data-price'); var _el = _c.querySelector('.cyk-card__price'); if (_el && _pm) { _el.textContent = _pm; } if (_pc) { _c.setAttribute('data-price', _pc); } } } });
    const self = this;
    this._obs = new MutationObserver(function () { self.schedule(); });
    this._obs.observe(this, { childList: true, subtree: true });
    this.schedule();
  }
  schedule() {
    if (this._t) { return; }
    const self = this;
    this._t = setTimeout(function () { self._t = null; self.evaluate(); }, 200);
  }
  evaluate() {
    this.applyThreshold();
    const dyn = this.querySelector('[data-cyk-dynamic]');
    if (!dyn) { this.reveal(); return; }
    const slots = parseInt(dyn.getAttribute('data-slots') || '0', 10);
    if (slots > 0 && dyn.children.length === 0 && !this._filling) {
      this._tries = 0;
      this.fillDynamic(dyn, slots);
    } else {
      this.reveal();
      this.trackView();
    }
  }
  inCartIds() { return (this.getAttribute('data-in-cart') || '').split(',').filter(Boolean); }
  shownIds() { return Array.prototype.slice.call(this.querySelectorAll('[data-cyk-card]')).map(function (c) { return c.getAttribute('data-product-id'); }).filter(Boolean); }
  gap() { return (parseInt(this.getAttribute('data-threshold') || '0', 10)) - (parseInt(this.getAttribute('data-cart-total') || '0', 10)); }
  money(c) { return '$' + (c / 100).toFixed(2); }
  reveal() { this.style.display = this.shownIds().length > 0 ? '' : 'none'; this.updateNav(); }
  updateNav() {
    const strip = this.querySelector('[data-cyk-strip]'); if (!strip) { return; }
    const overflow = strip.scrollWidth - strip.clientWidth > 4;
    const prev = this.querySelector('[data-cyk-prev]'); const next = this.querySelector('[data-cyk-next]');
    if (prev) { prev.hidden = !overflow; } if (next) { next.hidden = !overflow; }
  }
  applyThreshold() {
    const n = this.querySelector('[data-cyk-nudge]'); if (!n) { return; }
    const g = this.gap();
    if (g > 0 && g <= this.band) { n.textContent = "You're " + this.money(g) + ' away from free shipping'; n.hidden = false; }
    else { n.hidden = true; }
  }
  async fillDynamic(dyn, slots) {
    if (this._filling) { return; }
    this._filling = true;
    const anchor = this.getAttribute('data-anchor');
    if (!anchor) { this._filling = false; this.reveal(); this.trackView(); return; }
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const url = root + 'recommendations/products?section_id=cart-complete-your-kit&product_id=' + encodeURIComponent(anchor) + '&intent=related&limit=10';
    let html;
    try { html = await fetch(url).then(function (r) { return r.text(); }); } catch (e) { html = null; }
    if (!this.isConnected) { this._filling = false; return; }
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      let cards = Array.prototype.slice.call(doc.querySelectorAll('[data-cyk-card]'));
      const exclude = this.inCartIds().concat(this.shownIds());
      const seen = {};
      cards = cards.filter(function (c) {
        const id = c.getAttribute('data-product-id');
        if (!id || exclude.indexOf(id) !== -1 || c.getAttribute('data-available') === 'false') { return false; }
        if (seen[id]) { return false; } seen[id] = 1; return true;
      });
      const g = this.gap(), band = this.band;
      if (g > 0 && g <= band) {
        cards.sort(function (a, b) {
          const A = parseInt(a.getAttribute('data-price') || '0', 10) >= g ? 0 : 1;
          const B = parseInt(b.getAttribute('data-price') || '0', 10) >= g ? 0 : 1;
          return A - B;
        });
      }
      const frag = document.createDocumentFragment();
      cards.slice(0, slots).forEach(function (c) { frag.appendChild(document.importNode(c, true)); });
      if (this._obs) { this._obs.disconnect(); }
      dyn.appendChild(frag);
      if (this._obs) { this._obs.observe(this, { childList: true, subtree: true }); }
    }
    this._filling = false;
    if (dyn.children.length === 0 && this._tries < 2) {
      this._tries++;
      const self = this;
      setTimeout(function () { if (self.isConnected) { self.evaluate(); } }, 700);
      return;
    }
    this.reveal();
    this.trackView();
  }
  onClick(e) {
    const nav = e.target.closest ? e.target.closest('[data-cyk-prev],[data-cyk-next]') : null;
    if (nav) { const strip = this.querySelector('[data-cyk-strip]'); if (strip) { strip.scrollBy({ left: nav.hasAttribute('data-cyk-next') ? 170 : -170, behavior: 'smooth' }); } return; }
    const addBtn = e.target.closest ? e.target.closest('.cyk-card__add, [data-cyk-addbtn]') : null;
    if (addBtn) { e.preventDefault(); this.doAdd(addBtn.closest('[data-cyk-card]')); return; }
    const card = e.target.closest ? e.target.closest('[data-cyk-card]') : null;
    if (!card || !e.target.closest('a')) { return; }
    this.push('select_item', { item_list_id: 'complete_your_kit', item_id: card.getAttribute('data-product-id') });
  }
  async doAdd(card) {
    if (!card) { return; }
    const variantInput = card.querySelector('[data-cyk-variant]');
    const id = variantInput ? variantInput.value : '';
    const btn = card.querySelector('.cyk-card__add');
    if (!id) { const sel = card.querySelector('.cyk-card__size'); if (sel) { sel.classList.add('cyk-card__size--error'); if (sel.focus) { sel.focus(); } } return; }
    if (btn) { if (btn.dataset.busy === '1') { return; } btn.dataset.busy = '1'; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    try {
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: { _cyk_source: 'cart_drawer' } }] }) });
      if (!res.ok) { throw new Error('add failed'); }
      this.push('add_to_cart', { item_list_id: 'complete_your_kit', item_id: card.getAttribute('data-product-id') });
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
    } catch (err) { if (btn) { btn.dataset.busy = ''; btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = 'Try again'; } }
  }
  async onSubmit(e) {
    const form = e.target && e.target.closest ? e.target.closest('[data-cyk-add]') : null;
    if (!form) { return; }
    e.preventDefault();
    const card = form.closest('[data-cyk-card]');
    const variantInput = form.querySelector('[data-cyk-variant]');
    const id = variantInput ? variantInput.value : '';
    if (!id) { if (variantInput && variantInput.focus) { variantInput.focus(); } return; }
    const btn = form.querySelector('button');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: { _cyk_source: 'cart_drawer' } }] })
      });
      if (!res.ok) { throw new Error('add failed'); }
      this.push('add_to_cart', { item_list_id: 'complete_your_kit', item_id: card ? card.getAttribute('data-product-id') : null });
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
    } catch (err) {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = 'Try again'; }
    }
  }
  trackView() {
    if (this._viewed) { return; } this._viewed = true;
    const items = this.shownIds(); if (!items.length) { this._viewed = false; return; }
    this.push('view_item_list', { item_list_id: 'complete_your_kit', item_ids: items.join(',') });
  }
  push(event, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'cyk_' + event }, data));
      if (typeof window.gtag === 'function') { window.gtag('event', event, data); }
    } catch (e) {}
  }
}
if (!customElements.get('complete-your-kit')) { customElements.define('complete-your-kit', CompleteYourKit); }
